import { FormattedText, ImageComponent, SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import { useRouter } from "next/router";
import React, { useCallback } from "react";

import backArrow from "../../../../icons/backArrow.svg";
import {
  BackArrowButton,
  CopyAction,
  HeadingCard,
  HeadingDivider,
  HeroTopSection,
  OrderIdStrip,
  PersuasionTitle,
} from "../../OrderDetailV2.style";
import type { OrderDetailPageHeadingPWAProps } from "../../types";

export const OrderDetailPageHeadingPWA: React.FC<
  OrderDetailPageHeadingPWAProps
> = ({
  headerBackgroundColor,
  persuasionText,
  subTitle,
  bookingId,
  action,
}) => {
  const router = useRouter();

  const handleBackClick = () => {
    if (window.mmt_android_bridge) {
      window.mmt_android_bridge.closeWebView();
    } else {
      router.back();
    }
  };

  const handleCopy = useCallback(() => {
    if (bookingId && navigator.clipboard) {
      navigator.clipboard.writeText(bookingId);
    }
  }, [bookingId]);

  const gradient =
    headerBackgroundColor && headerBackgroundColor.length >= 2
      ? `linear-gradient(to right, ${headerBackgroundColor.join(", ")})`
      : undefined;

  return (
    <HeadingCard gradient={gradient}>
      <HeroTopSection>
        <BackArrowButton type="button" onClick={handleBackClick}>
          <ImageComponent src={backArrow.src} width="24px" height="24px" />
        </BackArrowButton>
      </HeroTopSection>
      {persuasionText && (
        <PersuasionTitle>
          <FormattedText
            value={persuasionText}
            baseStyle={{ fontSize: "24px", fontWeight: 700 }}
          />
        </PersuasionTitle>
      )}

      {subTitle && (
        <>
          <HeadingDivider />
          <OrderIdStrip>
            <SpanTag fontSize="sm" color={theme.greyText9}>
              {subTitle}
            </SpanTag>
            {action?.title && (
              <CopyAction type="button" onClick={handleCopy}>
                {action.title.charAt(0).toUpperCase() + action.title.slice(1)}
                {action.icon && (
                  <ImageComponent
                    src={action.icon}
                    width="16px"
                    height="16px"
                  />
                )}
              </CopyAction>
            )}
          </OrderIdStrip>
        </>
      )}
    </HeadingCard>
  );
};
